import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-confirm-place-order',
  templateUrl: './confirm-place-order.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirm-place-order.component.scss']
})
export class ConfirmPlaceOrderComponent {

  @Input() dialogRef: MatDialogRef<any>;

  confirmSaveOrder() {
    this.dialogRef.close(true);
  }

}
